import React from "react";

import { Typography, Box, Modal } from "@mui/material";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { FinanceData, FinanceDataValues } from "../../types";

interface MainInfoUpdateModalInterface {
  updateFinancialData: (string: string, value: FinanceDataValues) => void;
  closeModal: () => void;
  open: boolean;
  financeData: FinanceData;
}

const MainInfoUpdateModal: React.FC<MainInfoUpdateModalInterface> = ({
  updateFinancialData,
  closeModal,
  open,
  financeData,
}) => {
  return (
    <>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            padding: 2,
            mt: 10,
            backgroundColor: (theme) => theme.palette.background.paper,
            width: "95%",
            maxWidth: "400px",
            marginInline: "auto",
          }}
        >
          <Box>
            <label style={{ display: "flex", flexDirection: "column" }}>
              <Typography>Title</Typography>
              <input
                value={financeData.title}
                onChange={(e) => {
                  updateFinancialData("title", e.target.value);
                }}
              />
            </label>
          </Box>
          <Box>
            <label style={{ display: "flex", flexDirection: "column" }}>
              <Typography>Description</Typography>
              <input
                value={financeData.description}
                onChange={(e) => {
                  updateFinancialData("description", e.target.value);
                }}
              />
            </label>
          </Box>
          <Box>
            <label style={{ display: "flex" }}>
              <Typography>Start Date:{` `}</Typography>

              <DatePicker
                name="startDate"
                selected={financeData.startDate}
                onChange={(date) => {
                  if (date) {
                    updateFinancialData("startDate", new Date(date));
                  }
                }}
              />
            </label>
          </Box>
          <label style={{ display: "flex" }}>
            <Typography>End Date:{` `}</Typography>

            <DatePicker
              selected={financeData.endDate}
              onChange={(date) => {
                if (date) {
                  updateFinancialData("endDate", new Date(date));
                }
              }}
            />
          </label>
          <button onClick={closeModal}>Done</button>
        </Box>
      </Modal>
    </>
  );
};

export default MainInfoUpdateModal;
